"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _utils from "./utils";
import _styles from "./GrayTouchpointBtn.module.css";

export function GrayTouchpointBtn({ as: _Component = _Builtin.Block }) {
  return (
    <_Component
      className={_utils.cx(_styles, "gray-touchpoint-btn")}
      id={_utils.cx(
        _styles,
        "w-node-_11a789f4-44c0-c337-33e0-61de0c081aaf-0c081aaf"
      )}
      tag="div"
    >
      <_Builtin.Block className={_utils.cx(_styles, "ms-h6")} tag="div">
        {"Build Your Network"}
      </_Builtin.Block>
      <_Builtin.Block className={_utils.cx(_styles, "text-block-58")} tag="div">
        {
          "Connect with thousand of industry professionals. Join in-person and online events designed to help guide your career"
        }
      </_Builtin.Block>
    </_Component>
  );
}
